module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Neil LaBute\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Neil LaBute")]), _vm._v(" is a playwright, filmmaker, and fiction writer. His most recent work for the stage is "), _c('I', [_vm._v("The Distance from Here, ")]), _vm._v("which premiered Off Broadway in 2004.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19m90gI/tc-custom/9781429998314.jpg?1732052883422",
      "alt": "This image is the cover for the book This Is How It Goes"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("This Is How It Goes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Belinda and Cody Phipps "), _c('i', [_vm._v("appear")]), _vm._v(" a typical Midwestern couple: teenage sweethearts, children, luxurious home. Typical except that Cody is black--\"rich, black, and different,\" in the words of Belinda, who finds herself attracted to a former (white) classmate. As the battle for her affections is waged, Belinda and Cody frankly doubt the foundation of their initial attraction, opening the door wide to a swath of bigotry and betrayal. Staged on continually shifting moral ground that challenges our received notions about gender, ethnicity, and even love itself, "), _c('i', [_vm._v("This Is How It Goes")]), _vm._v(" unblinkingly explores the myriad ways in which the wild card of race is played by both black and white in America.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0